// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CardSeparator from "./CardSeparator.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as NLOrderPartnerDetailsVm from "./vm-mapper/NLOrderPartnerDetailsVm.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as OrderDashboardDataMachine from "../../../../app/order/OrderDashboardDataMachine.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

var cash_icon = OrderDashboardAssetsManager.getImage("cash.svg");

function getSettlementsTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Mode"
            },
            accessor: (function (s) {
                return {
                        TAG: /* Text */0,
                        _0: s.mode
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Settlement Time"
              },
              accessor: (function (s) {
                  return {
                          TAG: /* Text */0,
                          _0: s.time
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Amount"
                },
                accessor: (function (s) {
                    return {
                            TAG: /* Text */0,
                            _0: s.amount
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getInclusionsTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Title"
            },
            accessor: (function (i) {
                return {
                        TAG: /* Text */0,
                        _0: i.title
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Amount"
              },
              accessor: (function (i) {
                  return {
                          TAG: /* Text */0,
                          _0: i.amount
                        };
                })
            },
            tl: /* [] */0
          }
        };
}

function getViewLabel(partner_earnings) {
  return List.map((function (e) {
                return {
                        label: e.default_title,
                        value: {
                          TAG: /* Text */0,
                          _0: e.amount
                        }
                      };
              }), partner_earnings);
}

function NLOrderPartnerDetails(Props) {
  var order_crn = Props.order_crn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setPartnerEarnings = match$1[1];
  React.useEffect((function () {
          OrderDashboardDataMachine.fetchPartnerEarnings(order_crn, (function (earnings) {
                  return Curry._1(setPartnerEarnings, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: earnings
                                      };
                              }));
                }), (function (err) {
                  return Curry._1(setPartnerEarnings, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: err
                                      };
                              }));
                }), country);
          
        }), []);
  var match$2 = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match$2.country);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Partner Details",
                                icon_src: cash_icon
                              });
                  })
              },
              action: undefined,
              className: "primary-info-card c-partner-info-card",
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: match$1[0],
                    children: (function (partner_earnings) {
                        var partner_details = NLOrderPartnerDetailsVm.getVm(partner_earnings, currency);
                        var match = partner_details.settlements;
                        var match$1 = partner_details.inclusions;
                        return React.createElement(React.Fragment, undefined, React.createElement(CardComponent$Catalyst.make, {
                                        title: "Partner Earnings",
                                        className: "info-card",
                                        children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(partner_details.earnings))
                                      }), React.createElement(CardSeparator.make, {}), React.createElement(CardComponent$Catalyst.make, {
                                        title: "Settlements",
                                        className: "info-card",
                                        children: match ? React.createElement(TableComponent$Catalyst.make, {
                                                columns: getSettlementsTableColumnsSchema(undefined),
                                                rowData: partner_details.settlements,
                                                className: "c-nlo-table"
                                              }) : "No settlements exist"
                                      }), React.createElement(CardSeparator.make, {}), React.createElement(CardComponent$Catalyst.make, {
                                        title: "Inclusions",
                                        className: "info-card",
                                        children: match$1 ? React.createElement(TableComponent$Catalyst.make, {
                                                columns: getInclusionsTableColumnsSchema(undefined),
                                                rowData: partner_details.inclusions,
                                                className: "c-nlo-table"
                                              }) : "No inclusions exist"
                                      }));
                      })
                  })
            });
}

var make = NLOrderPartnerDetails;

export {
  cash_icon ,
  getSettlementsTableColumnsSchema ,
  getInclusionsTableColumnsSchema ,
  getViewLabel ,
  make ,
  
}
/* cash_icon Not a pure module */
